import { FlowDefinition } from 'vivaa-api';

import { BlockDurationField } from '../../ConfigFields/Duration';
import { BlockTextField } from '../../ConfigFields/TextField';

const { DurationUnits } = FlowDefinition;
type DurationUnits = FlowDefinition.DurationUnits;

export function CallbackFormFields() {
  return (
    <>
      <BlockTextField
        fieldName="config.message"
        label="Message"
        required
        helperText="Enter message to be sent to the external service."
      />
      <BlockDurationField
        fieldName="config.waitTime"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[DurationUnits.Minutes, DurationUnits.Seconds]}
        toggleLabel="Wait time"
        valueLabel="Time to wait before sending callback"
        valueHelperText="Enter the time to wait for a callback."
      />
      <BlockDurationField
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[DurationUnits.Hours, DurationUnits.Minutes, DurationUnits.Seconds]}
        toggleLabel="Timeout"
        valueLabel="Timeout (fail after duration)"
        valueHelperText="Enter the time to wait before timing out on callback."
      />
    </>
  );
}
